import React, { Suspense, lazy } from 'react';
import * as rsuite from 'rsuite';
import Shared from '../../Components/Frame/Shared';

// هر دو داشبورد با lazy بارگذاری می شوند تا در باندل اصلی نباشند.
// دلیل اصلی: نمودارها (recharts) حدود صد کیلوبایت فشرده هستند و فقط
// داشبورد مدیر از آنها استفاده می کند. با این تقسیم، کارشناس - که
// معمولا روی موبایل باز می کند - آن حجم را اصلا دریافت نمی کند.
const ManagerDashboard = lazy(() => import('../../Components/Dashboard/ManagerDashboard'));
const AgentDashboard = lazy(() => import('../../Components/Dashboard/AgentDashboard'));

// این صفحه خودش هیچ داده ای نمی گیرد - فقط بر اساس نقش تصمیم می گیرد
// کدام داشبورد رندر شود. کنترل واقعی سمت سرور است: اگر مقدار localStorage
// دستکاری شود، سرویس داشبورد مدیر خطای ۴۰۳ می دهد و کاربر بیرون می افتد.
const index = () => {

    const IsAdmin = localStorage.getItem("Permission") === "0";

    return (
        <Shared pageTitle={"داشبورد"}>
            <Suspense fallback={
                <div style={{ padding: 40, textAlign: 'center' }}>
                    <rsuite.Loader content="در حال آماده سازی داشبورد..." />
                </div>
            }>
                {
                    IsAdmin ?
                        <ManagerDashboard />
                        :
                        <AgentDashboard />
                }
            </Suspense>
        </Shared>
    )
}

export default index;
